module.exports = __webpack_public_path__ + "static/media/pic3.e3f0bc5a.jpg";